import { faCircle } from "@fortawesome/free-solid-svg-icons/faCircle";
import React from "react";
import styled, { keyframes } from "styled-components";
import { AtiraIcon } from "../AtiraIcon";

const bounce = keyframes`
  0%, 80%, 100% {
    transform: translateY(0);
  } 
  40% {
    transform: translateY(-3px);
  }
`;

const Wrapper = styled.div`
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  margin-bottom: 0.5rem;
  width: fit-content;
  background: #e5e7eb;
  margin-right: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  color: #374151;
  font-size: 0.4rem;
`;

const BouncingIcon = styled.div<{ delay: number }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  animation: ${bounce} 1.4s infinite;
  animation-delay: ${(props) => props.delay}s;

  svg {
    display: block;
  }
`;

export const AIMessagePending: React.FC = () => {
  return (
    <Wrapper>
      <BouncingIcon delay={0}>
        <AtiraIcon icon={faCircle} />
      </BouncingIcon>
      <BouncingIcon delay={0.2}>
        <AtiraIcon icon={faCircle} />
      </BouncingIcon>
      <BouncingIcon delay={0.4}>
        <AtiraIcon icon={faCircle} />
      </BouncingIcon>
    </Wrapper>
  );
};
